<p-editor [(ngModel)]="value" [style]="{'height':'320px'}">
    <p-header>
        <span class="ql-formats">
      <select class="ql-header">
        <option value="1">Heading</option>
        <option value="2">Subheading</option>
        <option selected>Normal</option>
      </select>
      <select class="ql-font">
        <option selected>Sans Serif</option>
        <option value="serif">Serif</option>
        <option value="monospace">Monospace</option>
      </select>
    </span>
        <span class="ql-formats">
      <button class="ql-bold" aria-label="Bold"></button>
      <button class="ql-italic" aria-label="Italic"></button>
      <button class="ql-underline" aria-label="Underline"></button>
    </span>
        <span class="ql-formats">
      <select class="ql-color"></select>
      <select class="ql-background"></select>
    </span>
        <span class="ql-formats">
      <button class="ql-list" value="ordered" aria-label="Ordered List"></button>
      <button class="ql-list" value="bullet" aria-label="Unordered List"></button>
      <select class="ql-align">
        <option selected></option>
        <option value="center"></option>
        <option value="right"></option>
        <option value="justify"></option>
      </select>
    </span>
        <span class="ql-formats">
      <button class="ql-link" aria-label="Insert Link" (click)="insertLink()"></button>
    </span>
        <span class="ql-formats">
      <button class="ql-clean" aria-label="Remove Styles"></button>
      <button class="ql-html" aria-label="Underline" (click)="uploadFile()" *ngIf="showFileUpload"><i
          class="fas fa-file-pdf"></i></button>
    </span>
    </p-header>
</p-editor>